import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/shared/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/masterclasses/content.tsx");
